app.filter('escape', function () {
	return window.encodeURIComponent;
});